/**
 * Shared embryo-status constants. This file was historically the
 * fresh-straw v1 tab router + required-headers dumping ground, but after
 * Phase 2 the only exports still consumed outside this folder are the
 * status enums, which `embryo-app` and `edit-embryo-form` depend on.
 *
 * If/when a better home for these becomes obvious (e.g. `@/constants`),
 * move them there and update importers — but don't delete this file until
 * all external references are gone.
 */

export const EMBRYO_STATUS = {
  FROZEN: 1,
  IMPLANTED: 2,
  DISCARDED: 3,
  SHIPPED: 4,
  USED: 5,
  THAWED_AND_DISCARDED: 6,
  AI: 7,
  PER_PREG_PRICING_HOLD: 8,
  MISSING: 100000000,
} as const;

export const EMBRYO_STATUS_MAP = {
  [EMBRYO_STATUS.FROZEN]: 'Frozen',
  [EMBRYO_STATUS.IMPLANTED]: 'Implanted',
  [EMBRYO_STATUS.DISCARDED]: 'Discarded',
  [EMBRYO_STATUS.SHIPPED]: 'Shipped',
  [EMBRYO_STATUS.USED]: 'Used',
  [EMBRYO_STATUS.THAWED_AND_DISCARDED]: 'Thawed and Discarded',
  [EMBRYO_STATUS.AI]: 'AI',
  [EMBRYO_STATUS.PER_PREG_PRICING_HOLD]: 'Per Preg Pricing Hold',
};

export const EMBRYO_STATUS_MAP_WITH_MISSING = {
  ...EMBRYO_STATUS_MAP,
  [EMBRYO_STATUS.MISSING]: 'Missing',
};

export const ACTIVITY_STATE_CODE_MAP = {
  1: 'Deactivated',
  0: 'Activated',
};
